import { render, staticRenderFns } from "./AnswerSheet.vue?vue&type=template&id=25a3a8d8&scoped=true&"
import script from "./AnswerSheet.vue?vue&type=script&lang=js&"
export * from "./AnswerSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3a8d8",
  null
  
)

export default component.exports